import { defineComponent as _defineComponent } from 'vue'
import { useSalesBotStore } from "@/store/modules/salesBot";
import { storeToRefs } from "pinia";
import { ref, onMounted } from "vue";
import { SpecialRequirementsTypeKey } from "@/utils/enum";
import SalesBotSpecialRequirementOptionCard from '@/components/SalesBotSpecialRequirementOptionCard.vue'
import CUIcon from '@/components/CUIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotTripDetails',
  emits: ['form:validate'],
  setup(__props, { emit }) {



const { requirementOptions, tripEventTypeOptions, ada, spab, passengerCount, tripEventTypeKey, routeName } = storeToRefs(useSalesBotStore())
const { setAda, setSpab, setPassengerCount, setTripEventTypeKey, setRouteName }  = useSalesBotStore()

const MAX_ROUTE_NAME_LENGTH = 50

const errorMessage = ref('')
const isRequirementSelected = (key: SpecialRequirementsTypeKey): boolean => {
  if (key == SpecialRequirementsTypeKey.ADA) {
    return ada.value
  } else if (key == SpecialRequirementsTypeKey.SPAB) {
    return spab.value
  } else {
    console.warn('Attempting to check if undefined requirement is selected')
    return false
  }
}

const setSpecialRequirement = (key: SpecialRequirementsTypeKey, value: boolean): void => {
  if (key == SpecialRequirementsTypeKey.ADA) {
    return setAda(value)
  } else if (key == SpecialRequirementsTypeKey.SPAB) {
    return setSpab(value)
  } else {
    console.warn('Attempting to provide an undefined requirement setter for special requirements')
    return
  }
}

const updateRouteName = (value: string): void => {
  setRouteName(value)
  errorMessage.value = (value.length > MAX_ROUTE_NAME_LENGTH) ? `Name must be less than ${MAX_ROUTE_NAME_LENGTH} characters` : ''
  validate()
}

const updatePassengerCount = (value: number): void => {
  setPassengerCount(value)
  errorMessage.value = passengerCount.value > 0 ? '' : 'Number of passengers is required'
  validate()
}

const updateTripEventTypeKey = (value: string): void => {
  setTripEventTypeKey(value)
  validate()
}

onMounted(() => {
  validate()
})

const validate = (): boolean => {
  const isValid = passengerCount.value > 0 && tripEventTypeKey.value != null && routeName.value.length <= MAX_ROUTE_NAME_LENGTH
  emit('form:validate', isValid)
  return isValid
}


return { __sfc: true,emit, requirementOptions, tripEventTypeOptions, ada, spab, passengerCount, tripEventTypeKey, routeName, setAda, setSpab, setPassengerCount, setTripEventTypeKey, setRouteName, MAX_ROUTE_NAME_LENGTH, errorMessage, isRequirementSelected, setSpecialRequirement, updateRouteName, updatePassengerCount, updateTripEventTypeKey, validate, SalesBotSpecialRequirementOptionCard, CUIcon }
}

})